import React from 'react'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  paragrapHeader: {
    color: `${theme.palette.informative.main} !important`,
  },
}))

export default (props) => {
  const { title, body } = props
  const classes = useStyles()
  return (
    <div>
      <Typography
        variant="h6"
        className={clsx(classes.paragrapHeader, 'mt-36')}
      >
        {title}
      </Typography>
      {body && (
        <Typography variant="body1" className="mt-16">
          {body}
        </Typography>
      )}
      {props.children}
    </div>
  )
}
